import React from 'react';
import { Header, HeaderProps } from 'semantic-ui-react';
import './HeaderWithBar.less';

export interface HeaderWithBarProps extends HeaderProps {
  uppercase?: boolean;
}

export const HeaderWithBar = (props: HeaderWithBarProps) => {
  const { uppercase, className, ...allOtherProps } = props;
  return (
    <Header
      {...allOtherProps}
      className={`pos-highlight-bar ${uppercase ? 'uppercase ' : ''} ${
        className != undefined ? className : ''
      }`}
    />
  );
};
